import { writeCreateTieredEdition } from '../actions/wallet/writeCreateTieredEdition.mjs';
import { writeMintTieredEdition } from '../actions/wallet/writeMintTieredEdition.mjs';

function walletTieredEditionActions(client) {
  return {
    writeCreateTieredEdition: (args) => writeCreateTieredEdition(client, args),
    writeMintTieredEdition: (args) => writeMintTieredEdition(client, args)
  };
}

export { walletTieredEditionActions };
